<template>
  <v-footer color="indigo" app>
    <span class="white--text"
      >&copy; 2019 - {{ current_year }} Gambia Ports Authority</span
    >
  </v-footer>
</template>

<script>
import moment from "moment";
export default {
  data: () => ({
    current_year: moment().format("YYYY")
  })
};
</script>
<style scoped></style>
